import { render, staticRenderFns } from "./cmpwhatsnew.vue?vue&type=template&id=5f779bce&scoped=true&"
import script from "./cmpwhatsnew.vue?vue&type=script&lang=js&"
export * from "./cmpwhatsnew.vue?vue&type=script&lang=js&"
import style0 from "./cmpwhatsnew.vue?vue&type=style&index=0&id=5f779bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f779bce",
  null
  
)

export default component.exports